//接口统一管理
import http from '@/request/http'

//根据token获取用户登录状态
export const getLoginStatusByToken = params => http.fetchPost( process.env.BASE_URL+'/api/user/getLoginStatusByToken', params);
//登录获取用户信息
export const getUserByToken = params => http.fetchGet('/login/v2/login/getUserByToken', params);
//图片验证码校验
export const getCodeCheck = params => http.fetchPostNoToken('/login/v2/code/check', params);
//获取验证码
export const getPicCode = params => http.fetchGetNoToken('/login/v2/code/getPicCode', params);
//获取手机验证码
export const getPhoneCode = params => http.fetchPostNoToken('/login/v2/code/getPhoneCode', params);
//登录
export const goLogin = params => http.fetchPostNoToken('/login/v2/login/login', params);
// 退出登录
export const logout = params => http.fetchPost('/login/v2/login/loginOut', params);
//注册
export const goRegister = params => http.fetchPostNoToken('/login/v2/login/register', params);
//注销用户
export const deleteUser = params => http.fetchPost('/login/v2/login/deleteUser', params);
//手机号绑定和换绑
export const bindPhone = params => http.fetchPost('/login/v2/login/bindPhone', params);
//验证手机验证码
export const checkPhoneCode = params => http.fetchPostNoToken('/login/v2/code/checkPhoneCode', params);
//忘记密码
export const forgetPsss = params => http.fetchPutNoToken('/login/v2/login/lostPassword', params);
//修改密码
export const vertifyPsss = params => http.fetchPut('/login/v2/login/updatePassword', params);
//设置密码
export const setPassword = params => http.fetchPut('/login/v2/login/setPassword', params);



// WEBPACK FOOTER //
// ./src/request/login.js